const normalizeBase = (value) => {
  if (!value) return '';
  return String(value).trim().replace(/\/+$/, '');
};

const getShareUrl = (type, id) => {
  const safeType = String(type || '').trim();
  const safeId = String(id || '').trim();
  if (!safeType || !safeId) return '';
  const envBase =
    process.env.REACT_APP_SHARE_BASE_URL || process.env.SHARE_BASE_URL || '';
  const origin =
    typeof window !== 'undefined' ? window.location.origin : '';
  // In dev, prefer the live origin to avoid stale/old ngrok bases
  const base =
    process.env.NODE_ENV === 'development'
      ? normalizeBase(origin || envBase)
      : normalizeBase(envBase || origin);
  const path = `/share/${encodeURIComponent(safeType)}/${encodeURIComponent(
    safeId,
  )}`;
  return base ? `${base}${path}` : path;
};

export default getShareUrl;
